<div class="w-full">
  <div class="w-full overflow-x-auto">
    <table class="w-full border-collapse">
      <thead>
        <tr class="bg-[#EBFBFF]">
          <th
            *ngFor="let column of columns"
            class="px-4 py-3 font-archivo font-bold text-[18px] text-gray-1200"
            [ngClass]="getAlignClass(column.align)"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of displayedData; trackBy: trackByRow"
          class="border-b border-gray-300 hover:bg-gray-50"
        >
          <td
            *ngFor="let column of columns"
            class="px-4 py-3 font-archivo text-[18px] text-gray-700"
            [ngClass]="getAlignClass(column.align)"
          >
            <ng-container *ngIf="column.actionRoute; else actionButtonOrDefault">
              <a
                [routerLink]="column.actionRoute(row)"
                [queryParams]="column.actionQueryParams ? column.actionQueryParams(row) : null"
                class="inline-block cursor-pointer rounded-[999px] bg-[#F26F24] px-[24px] py-[10px] font-['archivo'] text-[18px] text-white no-underline hover:bg-orange-600"
              >
                {{ column.actionLabel || 'View' }}
              </a>
            </ng-container>
            <ng-template #actionButtonOrDefault>
              <ng-container *ngIf="column.onAction; else customOrDefaultCell">
                <button
                  type="button"
                  class="cursor-pointer rounded-[999px] bg-[#F26F24] px-[24px] py-[10px] font-['archivo'] text-[18px] text-white hover:bg-orange-600"
                  (click)="column.onAction!(row); $event.stopPropagation()"
                >
                  {{ column.actionLabel || 'View' }}
                </button>
              </ng-container>
            </ng-template>
            <ng-template #customOrDefaultCell>
              <ng-container *ngIf="column.custom; else defaultCell">
                <ng-container
                  *ngIf="getCellTemplate(column.key) as cellTemplate"
                  [ngTemplateOutlet]="cellTemplate.templateRef"
                  [ngTemplateOutletContext]="{ $implicit: row, row: row, value: getRowColumnValue(row, column.key) }"
                ></ng-container>
              </ng-container>
              <ng-template #defaultCell>
                {{ getCellValue(column, row) }}
              </ng-template>
            </ng-template>
          </td>
        </tr>
        <tr *ngIf="displayedData.length === 0">
          <td
            [attr.colspan]="columns.length"
            class="px-4 py-8 text-center font-archivo text-[18px] text-gray-500"
          >
            {{ emptyMessage }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Figma NIPagination / PaginationItem Large Circular: SkipPrevious |‹ , ‹ , pages , › , ›| -->
  <nav
    *ngIf="showPagination"
    class="ni-table-pagination flex w-full flex-row flex-wrap items-center justify-center gap-2 border-t border-[#EAECF0] px-4 pb-2 pt-6"
    aria-label="Table pagination"
  >
    <button
      type="button"
      class="ni-table-pagination__nav inline-flex h-10 w-10 items-center justify-center rounded-full border-0 bg-transparent p-0 text-[#667085] disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="currentPage <= 1"
      (click)="goToFirstPage()"
      aria-label="First page"
    >
      <!-- SkipPrevious: vertical bar + single left chevron -->
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M5 5v10" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
        <path d="M15 5.5 9.5 10 15 14.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <button
      type="button"
      class="ni-table-pagination__nav inline-flex h-10 w-10 items-center justify-center rounded-full border-0 bg-transparent p-0 text-[#667085] disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="currentPage <= 1"
      (click)="onPreviousPage()"
      aria-label="Previous page"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M12.5 5.5 7 10l5.5 4.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <button
      *ngFor="let page of visiblePages"
      type="button"
      class="ni-table-pagination__page inline-flex h-10 w-10 items-center justify-center rounded-full border-0 bg-transparent p-0 font-archivo text-[16px] font-medium leading-none text-[#667085]"
      [class.ni-table-pagination__page--active]="page === currentPage"
      [ngClass]="
        page === currentPage
          ? 'bg-[#F2F4F7] font-semibold text-[#101828]'
          : 'hover:bg-[#F2F4F7] hover:text-[#344054]'
      "
      [attr.aria-current]="page === currentPage ? 'page' : null"
      [attr.aria-label]="'Page ' + page"
      (click)="goToPage(page)"
    >
      {{ page }}
    </button>

    <button
      type="button"
      class="ni-table-pagination__nav inline-flex h-10 w-10 items-center justify-center rounded-full border-0 bg-transparent p-0 text-[#667085] disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="currentPage >= totalPages"
      (click)="onNextPage()"
      aria-label="Next page"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M7.5 5.5 13 10l-5.5 4.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <button
      type="button"
      class="ni-table-pagination__nav inline-flex h-10 w-10 items-center justify-center rounded-full border-0 bg-transparent p-0 text-[#667085] disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="currentPage >= totalPages"
      (click)="goToLastPage()"
      aria-label="Last page"
    >
      <!-- SkipNext: single right chevron + vertical bar -->
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M5 5.5 10.5 10 5 14.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 5v10" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
      </svg>
    </button>
  </nav>
</div>
